export default "__VITE_ASSET__f8da7a34__"